module.exports = __webpack_public_path__ + "static/media/19ESCAP37.354db476.jpg";